import { AlertType } from './types/alert-type';

/*
 * Model for Alert
 */
export class Alert {
  /**
   * Channel of the alert,
   * in order to categorize alerts
   */
  channel: string;

  /**
   * Alert type
   */
  type: AlertType = AlertType.success;

  /**
   * The message to display, html is allowed
   */
  message: string;

  /**
   * The title
   */
  title: string;

  /**
   * Manually close the alert
   */
  autoclose = true;

  /**
   * Manually close the alert
   */
  duration = 5000;

  /**
   * Activate or deactivate translation
   */
  translate = true;

  constructor(attributes: Partial<Alert> = {}) {
    Object.assign(this, attributes);
  }
}
